import PropTypes from 'prop-types';

export const CategoryBannerDefaultProps = {
  className: null,
  categoryName: null,
  url: '',
  categoryFromBack: false,
  image: null,
  upperCategory: '',
  upperCategorySlug: '',
};

export const CategoryBannerPropTypes = {
  categoryFromBack: PropTypes.bool,
  className: PropTypes.string,
  categoryName: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.shape({
    alt: PropTypes.string,
    url: PropTypes.string,
  }),
  upperCategory: PropTypes.string,
  upperCategorySlug: PropTypes.string,
};
